import React, { useEffect, useState } from "react";

import { useGetOrganizationTenantReports } from "hooks/useOrganizations";

import { PaginationTable } from "js/components/types";

import TenantReportCardListPresentation from "./TenantReportCardListPresentation";

interface TenantReportCardListForOrganizationProps {
  showAdvisorColumn?: boolean;
  searchFilter?: string;
}

const TenantReportCardListForOrganization: React.FC<
  TenantReportCardListForOrganizationProps
> = ({ showAdvisorColumn = false, searchFilter = "" }) => {
  const [pagination, setPagination] = useState<PaginationTable>({
    current: 1,
    pageSize: 6,
    total: 0,
  });

  const { data, isLoading } = useGetOrganizationTenantReports(
    pagination,
    searchFilter,
  );

  useEffect(() => {
    if (data?.count) {
      setPagination((prev) => ({
        ...prev,
        total: data.count,
      }));
    }
  }, [data?.count]);

  const handlePageChange = (page: number) => {
    setPagination((prev) => ({ ...prev, current: page }));
  };

  return (
    <TenantReportCardListPresentation
      data={data?.results || []}
      isLoading={isLoading}
      pagination={pagination}
      onPageChange={handlePageChange}
      showAdvisorColumn={showAdvisorColumn}
    />
  );
};

export default TenantReportCardListForOrganization;
